import React from 'react';

type ConfirmModalProps = {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmModal: React.FC<ConfirmModalProps> = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="modal-overlay py-4">
      <div className="modal h-40 flex flex-col justify-center items-center">
        <p className='mt-10 font-semibold'>{message}</p>
        <div className='flex flex-row justify-center py-10 gap-4'>
            <button className='bg-gray-800 text-white p-4 w-40 h-12' onClick={onConfirm}>Confirm</button>
            <button className='bg-red-800 text-white p-4 w-40 h-12' onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};
